export default {
  root: {
    borderColor: '#000000 !important'
  }
}
